import config from './config';

/**
 * Robots.txt configuration for search engine crawlers.
 *
 * Defines which paths crawlers can and cannot access. Patterns follow
 * SEO best practices for Next.js e-commerce sites.
 *
 * @see https://developers.google.com/search/docs/crawling-indexing/robots/intro
 */
const robots = config({
  default: {
    default: {
      /**
       * Base paths to disallow for all brands.
       *
       * These patterns follow SEO best practices for Next.js e-commerce.
       * SFCC-specific patterns are intentionally excluded as they use
       * different URL structures than this Next.js implementation.
       *
       * **WARNING**: Do not override this setting in brand configs. Overriding
       * replaces all base patterns, removing essential SEO protections. Use
       * `disallow` for brand-specific paths instead.
       */
      baseDisallow: [
        // User-specific pages requiring authentication.
        '/cart*',
        '/checkout*',
        '/account*',
        '/wishlist*',
        '/register*',

        // Search results create infinite URL variations.
        '*/search/*',

        // Plus signs in URLs create duplicate content.
        '/*+',

        // API and technical endpoints.
        '/api/*',
        '/*.json$',
        '/*_buildManifest.js$',
        '/*_middlewareManifest.js$',
        '/*_ssgManifest.js$'
      ] as Array<string>,

      /**
       * Brand-specific paths to disallow beyond the base patterns.
       * These are merged with `baseDisallow` in the route handler.
       */
      disallow: [] as Array<string>,

      /**
       * Paths to explicitly allow (overrides disallow patterns).
       * Use when a subfolder of a disallowed path needs crawler access.
       */
      allow: [] as Array<string>
    }
  },
  'UGG-US': {
    default: {
      // UGG Closet is a special sale section that should be indexed.
      allow: ['/uggcloset'],
      // Private sale requires authentication.
      disallow: ['/private-sale*']
    }
  }
});

export default robots;
